// extracted by mini-css-extract-plugin
export default {"heading":"InvestorsJoinPage_heading__XqqV9","content":"InvestorsJoinPage_content__dOh0B"};